export default __webpack_public_path__ + "static/media/b35.ea01d7a9.png";